export const environment = {
  production: true,
  BaseUrl: window.location.origin,
  Api: '/api/',
  BaseAssets: 'https://tamubucketr18.s3.amazonaws.com/riskplatformv1.0/0_images',
  qa: false
};
